import { createIcon } from './createIcon'

export const longSortArrowIconPath =
  'M3.33333 13.475L1.175 11.325L0 12.5L4.16667 16.6667L8.33333 12.5L7.15833 11.325L5 13.475V0H3.33333V13.475Z'

export const longSortArrowIconViewBox = '0 0 9 17'

export const LongArrowDownIcon = createIcon({
  displayName: 'LongArrowDownIcon',
  viewBox: longSortArrowIconViewBox,
  path: [<path d={longSortArrowIconPath} fill="currentColor" />],
})
